import { useAuth0 } from "@auth0/auth0-react";

export default function withAuth(Component) {
  return (props) => <Component {...props} auth={useAuth0()} />;
}
